import GroupManageSaveButton from "discourse/components/group-manage-save-button";
import GroupsFormProfileFields from "discourse/components/groups-form-profile-fields";

export default <template>
  <form class="groups-form form-vertical">
    <GroupsFormProfileFields
      @disableSave={{@controller.saving}}
      @model={{@controller.model}}
    />
    <GroupManageSaveButton
      @model={{@controller.model}}
      @saving={{@controller.saving}}
    />
  </form>
</template>
